import { DEFAULT_POST_LOGIN_PATH } from '@/lib/auth/constants';

export const BRAND_CHOOSER_PATH = '/brands';

const MOBILE_POST_LOGIN_PATH = '/Home';

type SignedInLanding = {
  hasBrand: boolean;
  isMobile: boolean;
};

// gloss
export const signedInLanding = ({ hasBrand, isMobile }: SignedInLanding): string => {
  if (!hasBrand) return BRAND_CHOOSER_PATH;

  return isMobile ? MOBILE_POST_LOGIN_PATH : DEFAULT_POST_LOGIN_PATH;
};
